var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfinity = function SvgInfinity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 107 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 7.5,
    clipPath: "url(#infinity_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.796 23.75a24 24 0 0 0-2.546 4.262c-1.62 3.475-2.5 7.45-2.5 11.675 0 13.645 9.179 24.688 22.815 24.688 6.414 0 12.672-5.463 17.5-11.25s14.027-21.951 18.864-27.5S73.88 15 80.063 15c13.64 0 22.437 11.066 22.437 24.688 0 6.139-1.788 11.759-5 16.08m-58.75-36.11a30 30 0 0 1 2.5 2.292c5.16 5.268 8.904 12.474 11.875 17.738 3.269 5.789 8.194 13.93 14.375 19.255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 15.002a23.5 23.5 0 0 0-5 .592M85 63.861a23.4 23.4 0 0 1-4.937.514H80",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infinity_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 10h106.25v60H0z"
  })))));
};
export default SvgInfinity;